"use client"
import React from "react";

const WarrantyPage = () => {
  return (
    <div className="bg-white p-8 shadow-lg rounded-lg max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-4 text-center">Warranty Information</h1>
      
      <p className="text-lg mb-6">
        The <strong>Spanda Elite Digital Stethoscope</strong> comes with a 
        <strong> two-year (24 months) warranty</strong>. The warranty begins on the 
        date of purchase, which is indicated on the original purchase receipt.
      </p>

      <p className="text-lg mb-6">
        We recommend registering your warranty online at 
        <a 
          href="https://www.spanda.life" 
          className="text-blue-600 hover:underline"
          target="_blank" 
          rel="noopener noreferrer"
        > www.spanda.life
        </a>.
        You will need the serial number of the stethoscope and a copy of the purchase receipt for registration. 
        If registered within 7 calendar days from the date of purchase, the warranty will be extended by an 
        additional 3 months.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Terms and Conditions</h2>
      
      <ul className="list-disc pl-5 space-y-2 text-lg mb-6">
        <li>
          Any claim made under this warranty must include a copy of a valid proof of purchase showing the date 
          and place of purchase.
        </li>
        <li>The warranty starts from the date of purchase.</li>
        <li>Warranty covers defects due to material, manufacturing, or craftsmanship.</li>
        <li>
          Warranty excludes damage caused by normal wear and tear of parts, scratches, improper use, improper
          cleaning, and accidental damage.
        </li>
        <li>
          Warranty will be void if the product is repaired, dismantled, or altered by unauthorized personnel.
        </li>
      </ul>

      <p className="text-lg mb-6">
        For any warranty-related inquiries, please contact our support team at 
        <a href="mailto:support@spanda.life" className="text-blue-600 hover:underline"> support@spanda.life</a>.
      </p>
    </div>
  );
};

export default WarrantyPage;
